/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
==========================================================================================*/

// import themeConfig from '@/../themeConfig.js';
// import colors from '@/../themeConfig.js';

const state = {
    // isSidebarActive: true,
    // breakpoint: null,
    // sidebarWidth: 'default',
    // reduceButton: themeConfig.sidebarCollapsed,
    // bodyOverlay: false,
    // sidebarItemsMin: false,
    // theme: themeConfig.theme || 'light',
    // themePrimaryColor: colors.primary,
    // reduce: false,
};

export default state;